import { fetchWithAuth } from "~/common/fetch";

import type { MountViewer } from "./types";

let modulePromise: Promise<{ mountViewer: MountViewer }> | undefined;
export function loadViewer() {
  modulePromise ??= fetchWithAuth(`${process.env.API}/viewer/runtime`)
    .then(async (response) => {
      if (!response.ok) throw new Error(`Viewer runtime request failed (${response.status})`);
      const runtime = (await response.json()) as { module_url: string };
      const moduleUrl = new URL(runtime.module_url, window.location.href);
      if (moduleUrl.origin !== window.location.origin) throw new Error("Viewer modules must use the portal origin");
      return import(/* webpackIgnore: true */ moduleUrl.href) as Promise<{ mountViewer: MountViewer }>;
    })
    .catch((error: unknown) => {
      modulePromise = undefined;
      throw error;
    });
  return modulePromise;
}
